interface Props {
	label: string
	color: string
}

const ColorfulAbbreviation: React.FC<Props> = ({ label, color }) => {
	return (
		<div className="d-flex align-items-center justify-content-left" style={{ columnGap: '8px' }}>
			<div
				className="w-40px h-40px p-2 text-kumopack-base-white fw-bold d-flex align-items-center justify-content-center"
				style={{ borderRadius: '50%', backgroundColor: color }}>
				<div>{`${label.substring(0, 1).toUpperCase()}${label.substring(1, 2).toLowerCase()}`}</div>
			</div>
		</div>
	)
}

export default ColorfulAbbreviation
